import React from 'react'

const Footer = () => {
    const currentYear = new Date().getFullYear();
  return (
    <footer className="text-center p-4 text-sm text-gray-600">
        © <span className='font-semibold'>Brainymed </span>{currentYear} All rights reserved.
    </footer>
  )
}

export default Footer
